import type { ReactNode } from 'react';

export const symbol_play_for_work: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320.5-217Q253-274 242-360q-2-11.2 6.5-19.6 8.5-8.4 21.25-8.4t21.38 6.85q8.62 6.86 10.87 18.15 10 62 60 102.5T480-220q68 0 118-40.5T658-363q2.25-11.29 10.88-18.15 8.62-6.85 21.37-6.85 12.75 0 21.25 8.4T718-360q-11 86-78.5 143T480-160q-92 0-159.5-57ZM447-473v-255q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v254l67-67q9.27-9 21.64-8.5 12.36.5 21.75 9.5 8.61 9 8.61 21.5t-9 21.5L498-379q-5 5-10.13 7-5.14 2-11 2-5.87 0-10.87-2-5-2-10-7L337-498q-9-9-9-21.16t8.61-21Q346-549 358.47-549q12.46 0 21.53 9l67 67Z"
		/>
	</svg>
);
